/**
 * Converts data to table data and metadata.
 * 
 * @param {any} data
 */
export default function (data) {

    return new TableData(data);
}

class TableData {
    constructor(data) {
        this.rowdata = data.map(x => new RowData(x));
    }

    get metadata() {
        return this.rowdata.map( (x, index) => { return { row: index, id: x.id} });
    }

    get data() {
        return this.rowdata.map(x => x.data);
    }
}

class RowData {
    constructor(raw) {
        this.id = raw.id;
        delete raw.id;
        this.data = raw;
    }
}




// WEBPACK FOOTER //
// ./App/components/Handsontable/loadData.js